<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title( style='padding : 10px') {{ title }}
          EditPenyelesaianUsulan()
</template>

<script>
import EditPenyelesaianUsulan from "@/components/EditPenyelesaianUsulan.vue";

export default {
  name: "EditClosingUsulan",
  components: {
    EditPenyelesaianUsulan,
  },
  data () {
    return {
      title: 'Penyelesaian Pekerjaan',
    }
  },
};
</script>
